module.exports = __webpack_public_path__ + "img/redeem_header.6fe173c2.png";